module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_6_5.91a590f0.png";